import React from 'react';

type AuthCardProps = {
  pageTestId: string;
  cardTestId: string;
  ariaLabel: string;
  title: string;
  slogan?: string;
  subtitle: string;
  children: React.ReactNode;
  hasBackground?: boolean;
};

export default function AuthCard({
  pageTestId,
  cardTestId,
  ariaLabel,
  title: _title,
  slogan,
  subtitle,
  children,
  hasBackground = true,
}: AuthCardProps) {
  const sloganText = slogan?.trim();
  const hasSlogan = Boolean(sloganText);

  return (
    <div className="login-shell" style={{background: hasBackground ? undefined : "none"}} data-testid={pageTestId}>
      <div className={`login-card${hasSlogan ? ' login-card--slogan' : ''}`} role="form" aria-label={ariaLabel} data-testid={cardTestId}>
        <div className="login-logo">
          <img src="/images/rid-logo-and-label.svg" alt="RID" />
          <div className={`login-subtitle${hasSlogan ? ' login-slogan' : ''}`}>{sloganText || subtitle}</div>
          {hasSlogan && <div className="login-subtitle">{subtitle}</div>}
        </div>
        {children}
      </div>
    </div>
  );
}
